import { Dialog, DialogPanel, Transition } from '@headlessui/react'
import { FaBoxOpen, FaCalendarAlt, FaMapMarkerAlt, FaWeightHanging } from 'react-icons/fa'


const ForeignRateCalcy = ({ rateData, onClose }) => {
    return (
        <div>

            <Transition show={Boolean(rateData)}>
                <Dialog className="relative z-50" onClose={onClose}>
                    <Transition.Child
                        // open={true}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-50 w-screen h-screen md:p-12 px-0 flex items-center justify-center overflow-y-auto">
                        <Transition.Child
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            {/* lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl */}
                            <Dialog.Panel className="relative w-full max-h-screen overflow-y-auto transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full ">
                                <h1 className='px-6 pt-6 font-bold text-lg'>International Rate Calculation & Offer</h1>

                                <div className='p-4 hidden md:block'>
                                    <div className="bg-white rounded-xl shadow overflow-hidden">
                                        <div className="bg-slate-50 px-6 py-4 text-lg font-bold text-gray-900">
                                            <span className="text-indigo-600">{rateData?.country}</span> <span className="text-indigo-600">{`${(rateData?.weight)}`}  {rateData?.destinationPincode ? `- ${rateData?.destinationPincode}` : ""}</span>
                                        </div>

                                        <div className="overflow-x-auto">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className=" text-left text-sm font-semibold text-gray-700">
                                                    <tr>
                                                        <th className="px-6 py-3">Shipping Service</th>
                                                        <th className="px-6 py-3">Door-to-Door Services</th>
                                                        <th className="px-6 py-3">Estimated Delivery Time</th>
                                                        <th className="px-6 py-3">Item Type</th>
                                                        <th className="px-6 py-3">Weight (kg)</th>
                                                        <th className="px-6 py-3 text-center">Total Payable Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-100">
                                                    {rateData?.rate.map((item, idx) => (
                                                        <tr key={idx} className="text-sm text-gray-800">
                                                            <td className="px-6 py-4 font-medium">
                                                                <div className="flex items-center gap-2 h-full">
                                                                    {item?.serviceType?.toUpperCase()} SERVICES
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 font-medium">
                                                                <div className='flex space-x-4'>
                                                                    {/* line  */}
                                                                    <div className='space-y-1 text-gray-400'>
                                                                        <div className="bg-gray-50 p-2 rounded-full text-slate-900 text-md">
                                                                            <FaBoxOpen />
                                                                        </div>
                                                                        <ul className='ms-3.5'>
                                                                            <li className='text-xs leading-3'>I</li>
                                                                            <li className='text-xs leading-3'>I</li>
                                                                            <li className='text-xs leading-3'>I</li>
                                                                        </ul>
                                                                        <div className="bg-gray-50 p-2 rounded-full text-slate-900 text-md">
                                                                            <FaMapMarkerAlt />
                                                                        </div>
                                                                    </div>
                                                                    <div className='space-y-7 flex-initial w-full text-ellipsis overflow-hidden'>
                                                                        {/* Origin */}
                                                                        <div className="flex items-center gap-3">

                                                                            <div>
                                                                                <div className="text-sm text-gray-500 font-medium">Origin</div>
                                                                                <div className="font-medium text-sm text-gray-800">India
                                                                                </div>
                                                                            </div>
                                                                        </div>


                                                                        {/* Destination */}
                                                                        <div className="flex items-center gap-3">

                                                                            <div>
                                                                                <div className="text-sm text-gray-500 font-medium">Destination</div>
                                                                                <div className="font-medium text-sm text-gray-800">{rateData?.country}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>


                                                            <td className="px-6  font-medium py-4">
                                                                <div className="flex items-center gap-2">
                                                                    <FaCalendarAlt className="text-slate-600" />
                                                                    <span>{item?.businessDays}</span> BUSINESS DAYS
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 font-medium">
                                                                <div className="flex items-center gap-2 h-full">
                                                                    {rateData?.itemType}
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 font-medium">
                                                                <div className="flex items-center gap-2 h-full text-gray-800">
                                                                    <FaWeightHanging className="text-slate-600 text-md" />
                                                                    {rateData?.weight}
                                                                </div>
                                                            </td>


                                                            <td className="px-6 py-4">
                                                                <div className="flex flex-col items-center">
                                                                    <span className="text-[10px] bg-gray-100 text-black px-2 py-0.5 cursor-pointer rounded-full mb-2">Intro Offer</span>

                                                                    <button className="inline-flex items-center gap-1 px-7 py-2 bg-slate-700 text-white rounded-md hover:bg-slate-800 transition text-sm font-semibold">
                                                                        {item?.serviceType?.toUpperCase()}  ₹{item?.rate}
                                                                        {['0.5 Kg', '1 Kg', '1.5 Kg', '2 Kg'].includes(rateData?.weight?.trim()) ? (<span>Total</span>) : (<span> / Per Kg</span>)}
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                                <div className="space-y-6 p-4 w-full max-w-3xl mx-auto block md:hidden">
                                    {rateData?.rate.map((item, idx) => (
                                        <div key={idx}>
                                            <p className='font-semibold mb-7'>International Shipping Guidelines & Conditions</p>
                                            <div className="text-md space-y-6">
                                                {item.instructions?.length > 0 && (
                                                    item.instructions.map((instruction, i) => {
                                                        // Split if you want "title: content" (like "Shipping Mode: CSB-IV")
                                                        const [title, ...descParts] = instruction.split(':');
                                                        const description = descParts.join(':').trim();

                                                        return (
                                                            <div key={i} className="space-y-2">
                                                                <p className="text-black font-semibold">• {title?.trim()} :</p>
                                                                <p className="text-slate-600">{description}</p>
                                                            </div>
                                                        );
                                                    })
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                <div className="bg-white px-4 gap-7 pt-5 pb-4 sm:p-6 sm:pb-4 grid md:grid-cols-2 grid-cols-1">
                                    <div>
                                        <h2 className="text-lg font-bold text-slate-800 mb-6">International Shipping Guidelines & Conditions</h2>
                                        {rateData?.rate.map((item, idx) => (
                                            <div key={idx} className='md:px-4 px-2 mb-6 d:mb-0'>
                                                <div className="text-md space-y-6">
                                                    {item.instructions?.length > 0 ? (
                                                        item.instructions.map((instruction, i) => {
                                                            // Split if you want "title: content" (like "Shipping Mode: CSB-IV")
                                                            const [title, ...descParts] = instruction.split(':');
                                                            const description = descParts.join(':').trim();

                                                            return (
                                                                <div key={i} className="space-y-0 text-sm">
                                                                    <p className="text-sm leading-relaxed font-bold text-slate-700">{title?.trim()} :</p>
                                                                    <p className=" text-sm leading-relaxed">{description}</p>
                                                                </div>
                                                            );
                                                        })
                                                    ) : ""}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="md:px-4 px-2 text-gray-800">
                                        <h2 className="text-lg font-bold text-slate-800 mb-6">Shipping & Pricing Policy</h2>

                                        <div className="space-y-6 text-sm leading-relaxed">
                                            <p>
                                                <strong className="text-slate-700">Inclusive of GST :</strong> All prices and shipping rates provided by our company are inclusive of
                                                <span className="font-medium"> 18% Goods and Services Tax (GST)</span>, as mandated under Indian taxation laws. This ensures complete transparency in pricing with no hidden tax components.
                                            </p>

                                            <p>
                                                <strong className="text-slate-700">Weight-Based Charges :</strong> Shipping charges are determined based on either the <span className="font-medium">actual physical weight</span> of the package or its <span className="font-medium">volumetric weight</span> — whichever is higher, in accordance with standard courier industry practices.
                                            </p>

                                            <p>
                                                <strong className="text-slate-700">Customs Duties & Delaysv :</strong> Please note that we do not accept liability or entertain complaints related to customs duties, taxes, or any delays arising from customs clearance procedures in the destination country.
                                            </p>

                                            <p>
                                                <strong className="text-slate-700">Special Handling Requests :</strong> If your shipment requires special handling — such as temperature control for sensitive goods — you must inform us in advance. Additional charges may apply for such services.
                                            </p>

                                            <p>
                                                <strong className="text-slate-700">Transit Time Disclaimer :</strong> All estimated transit times mentioned are tentative. The actual delivery timeline depends on factors such as flight connectivity, customs processing, and local delivery conditions.
                                            </p>

                                            <p>
                                                <strong className="text-slate-700">Rate Fluctuations :</strong> Kindly be advised that all rates and service conditions are subject to revision without prior notice due to market, fuel, or regulatory changes.
                                            </p>

                                            <p>
                                                <strong className="text-slate-700">Electronic Communication Consent :</strong> By using our services, you expressly consent to receive digital communications including shipment updates and service notifications via SMS, email, or other messaging platforms.
                                            </p>

                                            <p className="text-slate-500 text-xs">We appreciate your trust in our services and look forward to serving your logistics needs with efficiency and care.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="sticky bottom-0 bg-slate-50 px-4 py-3 sm:px-6">
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50 sm:mt-0"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </button>
                                </div> */}
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 sticky bottom-0" >
                                    {rateData?.rate.map((item, idx) => (
                                        <div key={idx}>
                                            <button
                                                type="button"
                                                onClick={onClose}
                                                className="inline-flex w-full md:mb-0 mb-1.5 justify-center rounded-md bg-slate-700 px-7 py-2 text-sm font-semibold text-white shadow-xs hover:bg-slate-900 sm:ml-3 sm:w-auto"
                                            >
                                                {item?.serviceType?.toUpperCase()}  ₹{item?.rate} {" "}
                                                {['0.5 Kg', '1 Kg', '1.5 Kg', '2 Kg'].includes(rateData?.weight?.trim()) ? (<span className='ms-1'> Total </span>) : (<span> / Per Kg</span>)}
                                            </button>
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        data-autofocus
                                        onClick={onClose}
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default ForeignRateCalcy
